// extracted by mini-css-extract-plugin
module.exports = {"container":"specialTabs_container__10KOe"};